import { practitionerCountriesQuery_practitionerCountries } from 'Services/BeGateway/Practitioner/__generated__/practitionerCountriesQuery';
import { getCountryLabel } from '../getCountryLabel';

export default (
  countries: practitionerCountriesQuery_practitionerCountries[],
) => {
  const countryOptions =
    countries && countries?.length > 0
      ? countries?.map(country => ({
          value: country?.name ?? '',
          label: getCountryLabel(country),
        }))
      : [];
  countryOptions.sort((a, b) => a.label.localeCompare(b.label));

  return countryOptions;
};
